export default {
  CARD_NAME: '苏打券',
}
